import { render, staticRenderFns } from "./WealthRule.vue?vue&type=template&id=4553a56c"
import script from "./WealthRule.vue?vue&type=script&lang=js"
export * from "./WealthRule.vue?vue&type=script&lang=js"
import style0 from "./WealthRule.vue?vue&type=style&index=0&id=4553a56c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports